module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/ja-aichi-8efaf805d7ee0afdeab787abd781dbcd.png";